import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import UserService from '../../services/UserService';
import { MicrosoftIcon } from '../../assets';
import logo_ekome from '../../assets/logo_ekome.png';
import { IntExt } from '../../lib/permissions';
import React from 'react';
import { buildRedirectTranslatedUrl } from '../../lib/helperFuncs';
import { useTranslation } from 'react-i18next';
import IconCard from '../../components/Cards/IconCard';
import { useNavigate } from 'react-router-dom';

const AdminLogin = ({
  redirectUriLogin = `${buildRedirectTranslatedUrl()}/admin/profile`,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  React.useEffect(() => {
    UserService.isAuthenticated() &&
      UserService.hasRole([IntExt.External]) &&
      UserService.doLogout({ redirectUri: redirectUriLogin });

    UserService.isAuthenticated() &&
      UserService.hasRole([IntExt.Internal]) &&
      navigate('/admin/profile');
  }, []);

  return (
    <>
      {!UserService.isAuthenticated()
        ? (
          <Grid
            container
            sx={{ display: 'flex', justifyContent: 'center', mt: 15 }}
          >
            <Grid item>
              <Card elevation={4} sx={{ width: '115%' }}>
                <CardHeader
                  title={
                    <>
                      <Typography
                        variant='h2'
                        component='div'
                        sx={{ padding: '8px 0' }}
                      >
                        {t('Συνδεθείτε')}
                      </Typography>
                      <Divider variant='fullWidth' />
                    </>
                  }
                ></CardHeader>
                <CardContent>
                  <IconCard
                    title={t('Email / Κωδικός')}
                    onClick={() =>
                      UserService.doLogin({ redirectUri: redirectUriLogin })
                    }
                    icon={
                      <img
                        src={logo_ekome}
                        alt='EKOME-logo'
                        style={{ maxWidth: '90px', maxHeight: '70px' }}
                      />
                    }
                  />
                  <IconCard
                    title={'Microsoft'}
                    onClick={() =>
                      UserService.doLogin({
                        idpHint: 'EKOME-MICROSOFT',
                        redirectUri: `${process.env.REACT_APP_APP_URL}/auth/keycloak/landpage`
                      })
                    }
                    icon={
                      <MicrosoftIcon sx={{ color: 'black', fontSize: '70px' }} />
                    }
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )
        : (
          <Box mt={3}>
            {UserService.hasRole([IntExt.External])
              ? (
                <></>
              )
              : (
                <Button
                  onClick={() =>
                    UserService.doLogout({ redirectUri: redirectUriLogin })
                  }
                >
                  Logout
                </Button>
              )}
          </Box>
        )}
    </>
  );
};
export default AdminLogin;
